import * as questionsAPI from 'utils/api/questions';
import * as udcAPI from 'utils/api/userdatacollection';
import { log } from 'utils/logger';
import { getResponseResult } from 'utils/mxResponseResult';
import { showFentchingScreen, removeFetchingScreen } from "utils/fetchingscreencontrol";
import {batchActions} from "redux-batched-actions";
import { setOutOfContent } from 'redux/actions/embed_status';
import { udcData } from 'config/config';


/* ========== ~~~~~~~~~~ CONTENT STATUS : ACTIONS ~~~~~~~~~~ ========== */
// ACTION
// utilized by reducers as a call to action to perform some kind of update to application state
// utilized in "_container" components and reducers



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

export const ADD_CONTENT = 'ADD_CONTENT';
export const ADVANCE_FRAME = 'ADVANCE_FRAME';
export const ADVANCE_MULTIPLE_FRAMES = 'ADVANCE_MULTIPLE_FRAMES';
export const SET_TOTAL_FRAME_COUNT = 'SET_TOTAL_FRAME_COUNT';
export const INJECT_CONTENT = 'INJECT_CONTENT';
export const ACTIVATE_CONTENT = 'ACTIVATE_CONTENT';
export const ACTIVATE_INJECTABLE_CONTENT = 'ACTIVATE_INJECTABLE_CONTENT';
export const SET_INJECTED_ID = 'SET_INJECTED_ID';
export const PAUSE_MULTIPLE_CONTENTS = 'PAUSE_MULTIPLE_CONTENTS';
export const RESUME_MULTIPLE_PAUSED_CONTENTS = "RESUME_MULTIPLE_PAUSED_CONTENTS";
export const UNPAUSE_CONTENT = 'UNPAUSE_CONTENT';
export const DEACTIVATE_CONTENT ='DEACTIVATE_CONTENT';
export const DEACTIVATE_CONTENTS ='DEACTIVATE_CONTENTS';
export const REMOVE_INJECTED_CONTENT_ID = 'DEACTIVATE_INJECTABLE_CONTENT';
export const SET_UNIQUE_STATE = 'SET_UNIQUE_STATE';
export const SET_UNIQUE_FRAME_STATUS = 'SET_UNIQUE_FRAME_STATUS';
export const ADVAVCE_FRAME_WITH_STATUS = 'ADVAVCE_FRAME_WITH_STATUS';
export const UPDATE_CONTENT_STATUS = 'UPDATE_CONTENT_STATUS';
export const SET_QUESTION_RESPONSE_RESULT = 'SET_QUESTION_RESPONSE_RESULT';
export const SET_ANSWER_CLICKED = 'SET_ANSWER_CLICKED';
export const SET_QUESTION_RESPONSE_ERROR = 'SET_QUESTION_RESPONSE_ERROR';
export const SET_STORY_RESPONSE_RESULT = 'SET_STORY_RESPONSE_RESULT';
export const SET_STORY_RESPONSE_FAIL = 'SET_STORY_RESPONSE_FAIL';
export const RECEIVE_UDC_SETTINGS = 'RECEIVE_UDC_SETTINGS';
export const RECEIVE_UDC_RESPONSE = 'RECEIVE_UDC_RESPONSE';


export const advanceFrame = (contentId) => ({
    type: ADVANCE_FRAME,
    contentId
});
export const advanceMultipleFrames = (contentId, numOfFrames) => ({
    type: ADVANCE_MULTIPLE_FRAMES,
    contentId,
    numOfFrames
});
export const setTotalFrameCount = (contentId, totalFrameCount) => ({
    type: SET_TOTAL_FRAME_COUNT,
    contentId,
    totalFrameCount
});
export const addContent = contentId => ({
    type: ADD_CONTENT,
    contentId
});
export const injectContent = (contentId, parentId, displayType, shouldParentPause) => ({
    type: INJECT_CONTENT,
    contentId,
    parentId,
    displayType,
    shouldParentPause
});
export const activateContent = (contentId) => ({
    type: ACTIVATE_CONTENT,
    contentId,
});
// Sets injectable content status to active. This action doesn't update associated parent content settings.
export const activateInjectableContent = (parentContentId, injectableContentId, injectedWithDisplayType, injectedWithPauseType, injectAtFrame, repeatEveryXFrames) => ({
    type: ACTIVATE_INJECTABLE_CONTENT,
    parentContentId,
    injectableContentId,
    injectedWithDisplayType,
    injectedWithPauseType,
    injectAtFrame,
    repeatEveryXFrames
});
// Adds injectable id to the parent's array of active injected contents. This action does't update injectable settings.
export const setInjectedId = (parentContentId, injectableId) => ({
    type: SET_INJECTED_ID,
    parentContentId,
    injectableId
});

export const pauseMultipleContents = contentIds => ({
    type: PAUSE_MULTIPLE_CONTENTS,
    contentIds
});
export const resumeMultiplePausedContents = pauseState => ({
    type: RESUME_MULTIPLE_PAUSED_CONTENTS,
    pauseState
});
// Changes paused property of parent content back to false to unpause parent flow. This action does't update injectable settings.
export const unpauseContent = (parentContentId, injectableContentId, injectedWithPauseType) => ({
    type: UNPAUSE_CONTENT,
    parentContentId,
    injectableContentId,
    injectedWithPauseType
});
// Resets injectable state to default. This action doesn't update associated parent content settings.
export const deactivateContent = contentId => ({
    type: DEACTIVATE_CONTENT,
    contentId
});
// Resets state of contents to default.
export const deactivateContents = contentIds => ({
    type: DEACTIVATE_CONTENTS,
    contentIds
});
// Removes injectable id to the parent's array of active injected contents. This action does't update injectable settings.
export const removeInjectedContentId = (parentContentId, injectableContentId) => ({
    type: REMOVE_INJECTED_CONTENT_ID,
    parentContentId,
    injectableContentId
});
export const setUniqueState = (contentId, uniqueState) => ({
    type: SET_UNIQUE_STATE,
    contentId,
    uniqueState
});
// frameStatus is set to 'unanswered' by default and can be reset to 'correct' and 'incorrect'.
export const setUniqueFrameStatus = (contentId, frameStatus, predictionOptionUUID) => ({
    type: SET_UNIQUE_FRAME_STATUS,
    contentId,
    frameStatus,
    predictionOptionUUID
});
export const advanceFrameWithStatus = (contentId, frameStatus, predictionOptionUUID) => ({
    type: ADVAVCE_FRAME_WITH_STATUS,
    contentId,
    frameStatus,
    predictionOptionUUID
});

// Updates contentStatus based on received content data
export const updateContentStatus = (contentId, data, isPQ) => ({
    type: UPDATE_CONTENT_STATUS,
    contentId,
    data,
    isPQ
});

export const setAnswerClicked = (contentId, frame, optionUUID) => ({
    type: SET_ANSWER_CLICKED,
    contentId,
    frame,
    optionUUID
});
export const setQuestionResponseResult = (contentId, frame, isFactualQuestion, result) => ({
    type: SET_QUESTION_RESPONSE_RESULT,
    contentId,
    frame,
    isFactualQuestion,
    result
});
export const setQuestionResponseError = (contentId, frame, errorData) => ({
    type: SET_QUESTION_RESPONSE_ERROR,
    contentId,
    frame,
    errorData
});

export const setStoryEngagedResult = (contentId, frame, isFactualQuestion, result) => ({
    type: SET_STORY_RESPONSE_RESULT,
    contentId,
    frame,
    isFactualQuestion,
    result
});

export const setStoryEngagedError = (contentId, frame, errorData) => ({
    type: SET_STORY_RESPONSE_FAIL,
    contentId,
    frame,
    errorData
});

const receiveUDCSettings = (contentId, data, isPubPortalPreview) => dispatch => {
    const ooc = data === null || data.constructor === Object && Object.keys(data).length === 0
    dispatch(batchActions([
        { type: RECEIVE_UDC_SETTINGS, contentId, data },
        removeFetchingScreen(),
        setOutOfContent(isPubPortalPreview || ooc ? null : null)
    ]))
};

const receiveUDCResponse = (contentId, response, skip, callback ) => dispatch => {
    if(!!response && !!callback) callback(response)
    dispatch(batchActions([
        { type: RECEIVE_UDC_RESPONSE, contentId, response, skip, callback },
    ]))
}

export const requestQuestionResponseResult = (contentId, frame, isFactualQuestion, responseDetails, isPubPortalPreview) => dispatch => {

    if(isPubPortalPreview) {
        const result = getResponseResult(responseDetails.contentUUID, responseDetails.contentProperties.optionUUID, responseDetails.contentType);
        return dispatch(setQuestionResponseResult(contentId, frame, isFactualQuestion, result))
    }
    return questionsAPI.postContentResponse(responseDetails)
        .then(result => dispatch(setQuestionResponseResult(contentId, frame, isFactualQuestion, result.response)),
            err => dispatch(setQuestionResponseError(contentId, frame, err)))
};

export const requestStoryResponseResult = (contentId, frame, isFactualQuestion, responseDetails, isPubPortalPreview) => dispatch => {

    if(isPubPortalPreview) {
        const result = getResponseResult(responseDetails.contentUUID, responseDetails.contentProperties.optionUUID, responseDetails.contentType);
        return dispatch(setStoryEngagedResult(contentId, frame, isFactualQuestion, result))
    }
    return questionsAPI.postContentResponse(responseDetails)
        .then(result => dispatch(setStoryEngagedResult(contentId, frame, isFactualQuestion, result.response)),
            err => dispatch(setStoryEngagedError(contentId, frame, err)))
};

export const saveContentSkipResponse = (contentId, responseData, isPubPortalPreview, callback) => dispatch =>
    isPubPortalPreview ? null : questionsAPI.postContentResponse(responseData)
        .then(result => log('skip recorded'),
            () => log('error on skip'));

export const getUDCSettings = (embedUUID, contentId, cookieId, isPubPortalPreview) => dispatch => {
    // For publisher portal process data set on the window by pub portal
    if (isPubPortalPreview) return dispatch(receiveUDCSettings(contentId, udcData, isPubPortalPreview));
    dispatch(batchActions([ setUniqueState(contentId, {phase: 'fetching'}), setTotalFrameCount(contentId, 1) ]));
    return udcAPI.fetchUDCSettings(embedUUID, cookieId)
        .then(data => dispatch(receiveUDCSettings(contentId, data, isPubPortalPreview)),
            () => dispatch(receiveUDCSettings(contentId, null, isPubPortalPreview)))
};

export const submitUDCData = (contentId, udcData, isPubPortalPreview, callback=null) => dispatch => {
    const skip = udcData.contentProperties.engagementType === 'SKIP';
    if (isPubPortalPreview) return dispatch(receiveUDCResponse(contentId, { validRequest: true }, skip, null));
    return questionsAPI.postContentResponse(udcData)
        .then(result => dispatch(receiveUDCResponse(contentId, result.response, skip, callback)),
            () => dispatch(receiveUDCResponse(contentId, null, skip, callback)))
};
